/* eslint-disable */
import 'components/disable-hover';
import objectFitImages from 'object-fit-images';

// Проверяет работоспособность Element.closest, если не поддерживается, то деградирует, до старых методов
(function() {
    // проверяем поддержку
    if (!Element.prototype.closest) {

        // реализуем
        Element.prototype.closest = function(css){
            let node = this;

            while (node) {
                if (node.matches(css)) {
                    return node;
                } else {
                    node = node.parentElement;
                }
            }

            return null;
        }
    }
})();

// Полифил для object-fit
const imagesFit = document.querySelectorAll('.j-object-fit');

objectFitImages(imagesFit);
/* eslint-enable */
